Bingo.ContractPropertyAutoselect = class {
    constructor($wrapper, options) {
        const defaults = {
            inputName: 'customer',
            relatedInputName: 'ownerId',
        };

        this.options = $.extend(defaults, options);
        this.wrapper = $wrapper;
        this.input = $wrapper.find(`[name='${this.options.inputName}']`);
        this.searchUrl = this.wrapper.attr('data-property-autoselect-search-url');
        const relatedInput = $(`[name='${this.options.relatedInputName}']`);
        const redrawUrl = this.wrapper.attr('data-property-autoselect-redraw-url');

        this.input.selectize({
            preload: true,
            plugins: ['remove_button'],
            placeholder: null,
            valueField: 'id',
            labelField: 'label',
            searchField: 'label',
            create: false,
            render: {
                item(item) {
                    return `<div title="${item.label}" class="M-autocompleteSelect__item"><div class="M-autocompleteSelect__itemInner">${item.label}</div></div>`;
                },
                option(item) {
                    return `<div class="M-autocompleteSelect__option">${item.label}</div>`;
                },
            },
            load: (query, callback) => {
                if (query.length > 0 && query.length < 3) {
                    return callback();
                }
                this.loadSuggestions(query).then(data => callback(data));

                return callback();
            },
            onInitialize() {
                const self = this;
                this.$control_input[0].type = 'text';
                this.$control_input.addClass('no-live-validation ');
                this.$control_input.addClass('A-textField__formElement');
                this.$control_input.addClass('js-textField__formElement');

                this.$dropdown.closest('.selectize-control').addClass('M-autocompleteSelect');
                this.$dropdown.closest('.selectize-control').find('.items').addClass('M-autocompleteSelect__items');
                this.$dropdown.addClass('M-autocompleteSelect__dropdown');
                this.$dropdown_content.addClass('M-autocompleteSelect__options');

                // Workaround: when input is lock allow to clear value anyway.
                this.$control.off('click', '.remove-single');
                this.$control.on('click', '.remove-single', (e) => {
                    e.preventDefault();
                    self.clear();
                });

                if (this.isFull()) {
                    // If value selected lock and hide input to disallow select another value. You have to clear value first.
                    this.lock();
                    this.$control_input.hide();
                    const wrap = this.$control_input.closest('.js-autocompleteSelect__wrap');
                    wrap.find('.js-textField').addClass('-labelUp');
                }

                this.$input.on('focus', function () {
                    this.focus();
                });
            },
            onChange(value) {
                // Trigger validation.
                this.$input[0].dispatchEvent(new Event('change'));
                if (value) {
                    const form = this.$control_input.closest('form');
                    form.find('[name="propertyType"]').val('standalone');
                    return $.nette.ajax({
                        type: 'GET',
                        url: redrawUrl,
                        data: form.find(':input').filter((index, element) => $(element).val() !== '').serialize(),
                    });
                }
                return null;
            },
            onItemAdd() {
                const wrap = this.$control_input.closest('.js-autocompleteSelect__wrap');

                // Lock and hide input to disallow select another value when value already selected. You have to clear value first.
                this.lock();
                this.$control_input.hide();
                wrap.find('.js-textField').addClass('-labelUp');
            },
            onClear() {
                const wrap = this.$control_input.closest('.js-autocompleteSelect__wrap');

                // Enable and show input to allow select new value.
                this.$control_input.show();
                this.unlock();
                wrap.find('.js-textField').removeClass('-labelUp');
                relatedInput[0].selectize.enable();
            },
        });
    }

    /**
     * Loads new suggestions from API
     * @param text Search phrase
     * @return Promise
     */
    loadSuggestions(text) {
        return $.nette.ajax({
            type: 'GET',
            url: this.searchUrl,
            data: {
                q: text, // Pass string from search input
            },
        }).then((payload, status, jqXHR) => {
            if (payload.status.code !== 1) {
                Bingo.AjaxFailed.showError(payload.status.message);
                return $.Deferred().reject(jqXHR); // Reject promise
            }

            return payload.data;
        }).then((suggestions) => {
            let data = [];
            // Transform API response to data for autocomplete [{label,  data}]
            for (const i in suggestions) {
                const suggestedData = suggestions[i];
                const suggest = Bingo.ContractPropertyAutoselect.getLabel(suggestedData);
                data = data.concat({
                    label: suggest,
                    id: suggestedData.id,
                });
            }

            return data;
        });
    }

    /**
     * Get label from suggested data
     * @param data
     */
    static getLabel(data) {
        return `${data.name}, ${data.reference_id}, ${data.search_name}`;
    }
};
